/* eslint-disable */
const elLang = require('element-plus/lib/locale/lang/en')

module.exports = {
  languageName: 'English',
  ...elLang.default,
  companyName: 'Shanghai Jingteng Information Technoledge Co., Ltd.',
  invalidRoute: 'Page dose not found，please check',
  login: {    
    title: 'Device Login',    
    usernamePlaceholder: 'please input your username',
    passwordPlaceholder: 'please input your password',
    sendAuth: "Send Authcode",
    inputAuthCode: "please input your authcode",
    login: "Login",
    inputUsername: "please input your username",
    inputPassword: "please input your password",  
    tip3: 'The password cannot be less than 6 digits',
    sendMessage: 'Send verification code',
    loginBtn: 'Login',
    techName: 'Jingteng SaaS',
    tipText: 'Verification code sent',
    needStrongPass: 'Your password does not meet the system password complexity requirements. Please modify it before continuing',
    tip: 'Tip',
    submit: 'OK',
    passwordError: 'Wrong account or password',
    passwordErrorExceedLimitation: 'account locked for 15 minutes',
    pemissionDeny: "no authority to this web",
    loginError: "login error, please check your network",
    authcodeError: "authcode error",
    noUserNote: '',
    registNow: 'create new account',
    logoutBtn: 'Logout'
  },  
  regist: {
    title: 'Create account',
    usernamePlaceholder: 'Input username',
    passwordPlaceholder: 'Input password',
    confirmPasswordPlaceholder: 'Re-enter the login password',
    telPlaceholder: 'Email or phone number',
    authcodePlaceholder: 'Verification code',
    sendAuth: "Send code",
    registBtn: 'Sign Up',
    privacyNote: 'I have read and agree to the "Jingteng User Agreement" and "Privacy Policy"',
    usernameTip: '5-25 characters, can contain letters or Chinese characters',
    passwordTip: 'Password does not meet requirements',
    confirmPasswordTip: 'The passwords entered twice do not match, please re-enter',
    telTip: 'Please enter your phone number',
    authcodeTip: 'Enter verification code',
    agreementNote: 'I have read and agree to ',
    agreementNote1: ' and ',
    privacyNote: 'Privacy Policy',
    EULANote: 'EULA',
    strongPassNote: 'The password should be at least 8 characters long and include uppercase and lowercase letters, numbers, and symbols',
    agreementTip: 'Please confirm that you agree to the agreement',
    userExistsTip: 'User already exists, please log in directly',
    registSuccessful: 'Registration successful, please log in',
    userExists: 'User already exists, please select another phone/email number',
    authcodeSent: 'Verification code sent',
    authcodeError: 'Error sending verification code, please try again later',
    registFailed: 'Registration failed, please refresh and try again',
    confirmPassNotMatch: 'The passwords entered twice do not match.',
    success: 'New Account created',
    goLogin: 'login'
  },
  sicialSignin:{
    aadGlobal: "Azure AD(Global)",
    aadChina: "Azure AD(China)",
    addTenantNotFound: 'Cannot find the corresponding Azure AD tenant. Please contact your tenant admin to bind the Azure AD tenant first.',
    aadLoginError: 'AAD Login Error'
  },
  twoFactor: {
    title: 'Two Factor',
    note: 'Please fill in the verification code you received.',
    authcodePlaceholder: 'Please enter SMS verification code',
    sendAuthcode: 'Send code',
    ok: 'ok'
  },  
  codeView: {
    title: 'Device Login',
    note: 'Please enter the 9 digits displayed on the device',
    confirm: 'Submit',
    codeRequire: 'Please input the 9-digit user code completely',
    varified: 'Varified',
    codeError: 'Verification failed, please re-enter'
  },
  errorView: {
    title: 'Error',
    note: 'Error! Please check the address entered'
  },
  noteView: {
    success: 'Verification succeeded!' ,
    note: 'Return to device to continue',
    logout: "Logout",
    verifyAgain: "Verify again"
  }
};
